Namespace 'App'

App.DropupSelectViewMixin =
  setUpDropup: ->
    @$el.addClass 'dropup-select'
    @$el.on 'chosen:showing_dropdown', @openSelectorUpwards

  openSelectorUpwards: =>
    @$('.chosen-drop').addClass 'chosen-drop-up'
